// extracted by mini-css-extract-plugin
module.exports = {"lockedRa":"styles_lockedRa__1OUZn"};